import * as React from 'react';
import CloseIcon from '@mui/icons-material/Close';

import { Customer } from 'types/Customer';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getCustomer } from 'services/clients/customers';

interface Props {
  customer: Customer;
  /** If supplied, this component will render an x */
  onClear?: () => void;
}

/**
 * Renders the small pill used to indicate a company customer
 */
export const CustomerTag: React.FC<Props> = (props) => {
  const { customer: originalCustomer, onClear } = props;

  // If this is a real customer tag (and not a temporary one), let's make sure
  // it is always up to date
  const queryClient = useQueryClient();
  const result = useQuery(
    ['customerTag', originalCustomer.id],
    () => getCustomer(originalCustomer.id),
    {
      initialData: () => {
        // Use the customer tag from the list query as the initial data
        return queryClient
          .getQueryData<Customer[]>(['customers'])
          ?.find((c) => c.id === originalCustomer.id);
      },
      enabled: !!originalCustomer.id,
    }
  );

  // This allows the component to fall back on the passed in customer object
  // which may be stale.
  const customer = result.data || originalCustomer;

  return (
    <div className="bg-gray-400 px-2 py-1 h-5 space-x-1 rounded overflow-hidden flex items-center max-w-full">
      <h4 className="text-dark font-bold uppercase truncate">{customer.code}</h4>
      {onClear && (
        <CloseIcon
          className="flex-shrink-0 cursor-pointer"
          onClick={() => onClear()}
          style={{ fontSize: 18 }}
        />
      )}
    </div>
  );
};
CustomerTag.displayName = 'CustomerTag.CustomerTag';
